import { BaseModel } from "./hateoas/base-model";

export class RejectionSupervisorModel extends BaseModel {
  analyzeReportUuid?: string;
  supervisorUuid?: string;
  descriptionRejection?: string;
}
